import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchChangeLogsFile = async ({ trialId, patientId }) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  params.append("trial", trialId);
  params.append("patient", patientId);

  const response = await axios.get(
    `${__API_URL__}/api/ecrf/get_change_logs_file/?${params.toString()}`,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return response.data;
};

const useGetChangeLogsFile = ({ trialId, patientId, enabled = true }) => {
  return useQuery({
    queryKey: ["ecrf_change_logs_file", trialId, patientId],
    queryFn: () => fetchChangeLogsFile({ trialId, patientId }),
    enabled: enabled && Boolean(trialId && patientId),
    refetchOnWindowFocus: false,
  });
};

export default useGetChangeLogsFile;
